import React from "react";
import "./Frame11732.css";

function Frame11732(props) {
  const { className } = props;

  return (
    <div className={`frame-112 ${className || ""}`}>
      <div className="next valign-text-middle inter-bold-mineral-green-18px">Next</div>
    </div>
  );
}

export default Frame11732;
